(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy', 'kvision-kvision-jquery-js-legacy', 'snabbdom', 'jquery-kotlin-jsLegacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'), require('kvision-kvision-jquery-js-legacy'), require('snabbdom'), require('jquery-kotlin-jsLegacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-select-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-bootstrap-select-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-select-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-select-js-legacy'.");
    }if (typeof this['kvision-kvision-jquery-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-select-js-legacy'. Its dependency 'kvision-kvision-jquery-js-legacy' was not found. Please, check whether 'kvision-kvision-jquery-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-select-js-legacy'.");
    }if (typeof snabbdom === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-select-js-legacy'. Its dependency 'snabbdom' was not found. Please, check whether 'snabbdom' is loaded prior to 'kvision-kvision-bootstrap-select-js-legacy'.");
    }if (typeof this['jquery-kotlin-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-select-js-legacy'. Its dependency 'jquery-kotlin-jsLegacy' was not found. Please, check whether 'jquery-kotlin-jsLegacy' is loaded prior to 'kvision-kvision-bootstrap-select-js-legacy'.");
    }root['kvision-kvision-bootstrap-select-js-legacy'] = factory(typeof this['kvision-kvision-bootstrap-select-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-bootstrap-select-js-legacy'], kotlin, this['kvision-js-legacy'], this['kvision-kvision-jquery-js-legacy'], snabbdom, this['jquery-kotlin-jsLegacy']);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy, $module$kvision_kvision_jquery_js_legacy, $module$snabbdom, $module$jquery_kotlin_jsLegacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var ModuleInitializer = $module$kvision_js_legacy.io.kvision.ModuleInitializer;
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwISE = Kotlin.throwISE;
  var mutableListOf = Kotlin.kotlin.collections.mutableListOf_i5x0yv$;
  var throwCCE = Kotlin.throwCCE;
  var asList = Kotlin.kotlin.collections.asList_us0mfu$;
  var i18n = $module$kvision_js_legacy.io.kvision.i18n;
  var Object_init = Object;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var SimplePanel = $module$kvision_js_legacy.io.kvision.panel.SimplePanel;
  var FieldLabel = $module$kvision_js_legacy.io.kvision.form.FieldLabel;
  var InvalidFeedback = $module$kvision_js_legacy.io.kvision.form.InvalidFeedback;
  var StringFormControl = $module$kvision_js_legacy.io.kvision.form.StringFormControl;
  var MutableState = $module$kvision_js_legacy.io.kvision.state.MutableState;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var getPropertyCallableRef = Kotlin.getPropertyCallableRef;
  var getOrNull = Kotlin.kotlin.collections.getOrNull_yzln2o$;
  var Unit = Kotlin.kotlin.Unit;
  var getElementJQuery = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.getElementJQuery_tqt9mm$;
  var equals = Kotlin.equals;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var h = $module$snabbdom.h;
  var getElementJQueryD = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.getElementJQueryD_tqt9mm$;
  var toString = Kotlin.toString;
  var ensureNotNull = Kotlin.ensureNotNull;
  var InputSize = $module$kvision_js_legacy.io.kvision.form.InputSize;
  var asString = $module$kvision_js_legacy.io.kvision.utils.asString_ebgrb4$;
  var bindAllJQueryListeners = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.bindAllJQueryListeners_yw480n$;
  var removeAllJQueryListeners = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.removeAllJQueryListeners_yw480n$;
  var split = Kotlin.kotlin.text.split_ip8yn$;
  var GenericFormComponent = $module$kvision_js_legacy.io.kvision.form.GenericFormComponent;
  var FormInput = $module$kvision_js_legacy.io.kvision.form.FormInput;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var Widget$Widget$RefreshDelegateProvider_init = $module$kvision_js_legacy.io.kvision.core.Widget.RefreshDelegateProvider;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var Widget = $module$kvision_js_legacy.io.kvision.core.Widget;
  HttpType.prototype = Object.create(Enum.prototype);
  HttpType.prototype.constructor = HttpType;
  DataType.prototype = Object.create(Enum.prototype);
  DataType.prototype.constructor = DataType;
  Select.prototype = Object.create(SimplePanel.prototype);
  Select.prototype.constructor = Select;
  SelectDropdownAlign.prototype = Object.create(Enum.prototype);
  SelectDropdownAlign.prototype.constructor = SelectDropdownAlign;
  SelectInput.prototype = Object.create(SimplePanel.prototype);
  SelectInput.prototype.constructor = SelectInput;
  SelectOption.prototype = Object.create(Widget.prototype);
  SelectOption.prototype.constructor = SelectOption;
  function BootstrapSelectModule() {
    BootstrapSelectModule_instance = this;
    this.jquery_8be2vx$ = require('jquery');
    this.bootstrap_8be2vx$ = require('bootstrap');
    window['$'] = this.jquery_8be2vx$;
    window['jQuery'] = this.jquery_8be2vx$;
    window['bootstrap'] = this.bootstrap_8be2vx$;
    if ($.fn.dropdown === undefined) {
      $.fn.dropdown = {Constructor: {VERSION: '5.0.0'}};
    }this.AJAX_REQUEST_DELAY_8be2vx$ = 300;
    this.KVNULL_8be2vx$ = '#kvnull';
  }
  BootstrapSelectModule.prototype.initialize = function () {
    require('@rjaros/bootstrap-select/dist/css/bootstrap-select.min.css');
    require('@rjaros/bootstrap-select');
    require('kvision-assets/js/locales/bootstrap-select/bootstrap-select-i18n.min.js');
    require('ajax-bootstrap-select/dist/css/ajax-bootstrap-select.min.css');
    require('ajax-bootstrap-select');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.cs-CZ.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.de-DE.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.es-ES.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.fr-FR.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.it-IT.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.ja-JP.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.ko-KR.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.nl-NL.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.pl-PL.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.pt-BR.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.ru-RU.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.sr-SP.min.js');
    require('kvision-assets/js/locales/ajax-bootstrap-select/ajax-bootstrap-select.tr-TR.min.js');
    $.fn.selectpicker.Constructor.BootstrapVersion = '5';
    $.fn.selectpicker.Constructor.DEFAULTS.styleBase = 'form-control';
    $.fn.selectpicker.Constructor.DEFAULTS.style = '';
  };
  BootstrapSelectModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'BootstrapSelectModule', interfaces: [ModuleInitializer]};
  var BootstrapSelectModule_instance = null;
  function BootstrapSelectModule_getInstance() {
    if (BootstrapSelectModule_instance === null) {
      new BootstrapSelectModule();
    }return BootstrapSelectModule_instance;
  }
  function HttpType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function HttpType_initFields() {
    HttpType_initFields = function () {
    };
    HttpType$GET_instance = new HttpType('GET', 0, 'GET');
    HttpType$POST_instance = new HttpType('POST', 1, 'POST');
  }
  var HttpType$GET_instance;
  function HttpType$GET_getInstance() {
    HttpType_initFields();
    return HttpType$GET_instance;
  }
  var HttpType$POST_instance;
  function HttpType$POST_getInstance() {
    HttpType_initFields();
    return HttpType$POST_instance;
  }
  HttpType.$metadata$ = {kind: Kind_CLASS, simpleName: 'HttpType', interfaces: [Enum]};
  function HttpType$values() {
    return [HttpType$GET_getInstance(), HttpType$POST_getInstance()];
  }
  HttpType.values = HttpType$values;
  function HttpType$valueOf(name) {
    switch (name) {
      case 'GET':
        return HttpType$GET_getInstance();
      case 'POST':
        return HttpType$POST_getInstance();
      default:throwISE('No enum constant io.kvision.form.select.HttpType.' + name);
    }
  }
  HttpType.valueOf_61zpoe$ = HttpType$valueOf;
  function DataType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function DataType_initFields() {
    DataType_initFields = function () {
    };
    DataType$JSON_instance = new DataType('JSON', 0, 'json');
    DataType$JSONP_instance = new DataType('JSONP', 1, 'jsonp');
    DataType$XML_instance = new DataType('XML', 2, 'xml');
    DataType$TEXT_instance = new DataType('TEXT', 3, 'text');
    DataType$SCRIPT_instance = new DataType('SCRIPT', 4, 'script');
  }
  var DataType$JSON_instance;
  function DataType$JSON_getInstance() {
    DataType_initFields();
    return DataType$JSON_instance;
  }
  var DataType$JSONP_instance;
  function DataType$JSONP_getInstance() {
    DataType_initFields();
    return DataType$JSONP_instance;
  }
  var DataType$XML_instance;
  function DataType$XML_getInstance() {
    DataType_initFields();
    return DataType$XML_instance;
  }
  var DataType$TEXT_instance;
  function DataType$TEXT_getInstance() {
    DataType_initFields();
    return DataType$TEXT_instance;
  }
  var DataType$SCRIPT_instance;
  function DataType$SCRIPT_getInstance() {
    DataType_initFields();
    return DataType$SCRIPT_instance;
  }
  DataType.$metadata$ = {kind: Kind_CLASS, simpleName: 'DataType', interfaces: [Enum]};
  function DataType$values() {
    return [DataType$JSON_getInstance(), DataType$JSONP_getInstance(), DataType$XML_getInstance(), DataType$TEXT_getInstance(), DataType$SCRIPT_getInstance()];
  }
  DataType.values = DataType$values;
  function DataType$valueOf(name) {
    switch (name) {
      case 'JSON':
        return DataType$JSON_getInstance();
      case 'JSONP':
        return DataType$JSONP_getInstance();
      case 'XML':
        return DataType$XML_getInstance();
      case 'TEXT':
        return DataType$TEXT_getInstance();
      case 'SCRIPT':
        return DataType$SCRIPT_getInstance();
      default:throwISE('No enum constant io.kvision.form.select.DataType.' + name);
    }
  }
  DataType.valueOf_61zpoe$ = DataType$valueOf;
  function AjaxOptions(url, preprocessData, beforeSend, data, httpType, dataType, minLength, cache, clearOnEmpty, clearOnError, emptyRequest, requestDelay, restoreOnError, preserveSelected, processData) {
    if (url === void 0)
      url = null;
    if (preprocessData === void 0)
      preprocessData = null;
    if (beforeSend === void 0)
      beforeSend = null;
    if (data === void 0)
      data = null;
    if (httpType === void 0)
      httpType = HttpType$GET_getInstance();
    if (dataType === void 0)
      dataType = DataType$JSON_getInstance();
    if (minLength === void 0)
      minLength = 0;
    if (cache === void 0)
      cache = true;
    if (clearOnEmpty === void 0)
      clearOnEmpty = true;
    if (clearOnError === void 0)
      clearOnError = true;
    if (emptyRequest === void 0)
      emptyRequest = false;
    if (requestDelay === void 0)
      requestDelay = 300;
    if (restoreOnError === void 0)
      restoreOnError = false;
    if (preserveSelected === void 0)
      preserveSelected = false;
    if (processData === void 0)
      processData = false;
    this.url = url;
    this.preprocessData = preprocessData;
    this.beforeSend = beforeSend;
    this.data = data;
    this.httpType = httpType;
    this.dataType = dataType;
    this.minLength = minLength;
    this.cache = cache;
    this.clearOnEmpty = clearOnEmpty;
    this.clearOnError = clearOnError;
    this.emptyRequest = emptyRequest;
    this.requestDelay = requestDelay;
    this.restoreOnError = restoreOnError;
    this.preserveSelected = preserveSelected;
    this.processData = processData;
  }
  AjaxOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'AjaxOptions', interfaces: []};
  AjaxOptions.prototype.component1 = function () {
    return this.url;
  };
  AjaxOptions.prototype.component2 = function () {
    return this.preprocessData;
  };
  AjaxOptions.prototype.component3 = function () {
    return this.beforeSend;
  };
  AjaxOptions.prototype.component4 = function () {
    return this.data;
  };
  AjaxOptions.prototype.component5 = function () {
    return this.httpType;
  };
  AjaxOptions.prototype.component6 = function () {
    return this.dataType;
  };
  AjaxOptions.prototype.component7 = function () {
    return this.minLength;
  };
  AjaxOptions.prototype.component8 = function () {
    return this.cache;
  };
  AjaxOptions.prototype.component9 = function () {
    return this.clearOnEmpty;
  };
  AjaxOptions.prototype.component10 = function () {
    return this.clearOnError;
  };
  AjaxOptions.prototype.component11 = function () {
    return this.emptyRequest;
  };
  AjaxOptions.prototype.component12 = function () {
    return this.requestDelay;
  };
  AjaxOptions.prototype.component13 = function () {
    return this.restoreOnError;
  };
  AjaxOptions.prototype.component14 = function () {
    return this.preserveSelected;
  };
  AjaxOptions.prototype.component15 = function () {
    return this.processData;
  };
  AjaxOptions.prototype.copy_eo3vq1$ = function (url, preprocessData, beforeSend, data, httpType, dataType, minLength, cache, clearOnEmpty, clearOnError, emptyRequest, requestDelay, restoreOnError, preserveSelected, processData) {
    return new AjaxOptions(url === void 0 ? this.url : url, preprocessData === void 0 ? this.preprocessData : preprocessData, beforeSend === void 0 ? this.beforeSend : beforeSend, data === void 0 ? this.data : data, httpType === void 0 ? this.httpType : httpType, dataType === void 0 ? this.dataType : dataType, minLength === void 0 ? this.minLength : minLength, cache === void 0 ? this.cache : cache, clearOnEmpty === void 0 ? this.clearOnEmpty : clearOnEmpty, clearOnError === void 0 ? this.clearOnError : clearOnError, emptyRequest === void 0 ? this.emptyRequest : emptyRequest, requestDelay === void 0 ? this.requestDelay : requestDelay, restoreOnError === void 0 ? this.restoreOnError : restoreOnError, preserveSelected === void 0 ? this.preserveSelected : preserveSelected, processData === void 0 ? this.processData : processData);
  };
  AjaxOptions.prototype.toString = function () {
    return 'AjaxOptions(url=' + Kotlin.toString(this.url) + (', preprocessData=' + Kotlin.toString(this.preprocessData)) + (', beforeSend=' + Kotlin.toString(this.beforeSend)) + (', data=' + Kotlin.toString(this.data)) + (', httpType=' + Kotlin.toString(this.httpType)) + (', dataType=' + Kotlin.toString(this.dataType)) + (', minLength=' + Kotlin.toString(this.minLength)) + (', cache=' + Kotlin.toString(this.cache)) + (', clearOnEmpty=' + Kotlin.toString(this.clearOnEmpty)) + (', clearOnError=' + Kotlin.toString(this.clearOnError)) + (', emptyRequest=' + Kotlin.toString(this.emptyRequest)) + (', requestDelay=' + Kotlin.toString(this.requestDelay)) + (', restoreOnError=' + Kotlin.toString(this.restoreOnError)) + (', preserveSelected=' + Kotlin.toString(this.preserveSelected)) + (', processData=' + Kotlin.toString(this.processData)) + ')';
  };
  AjaxOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.url) | 0;
    result = result * 31 + Kotlin.hashCode(this.preprocessData) | 0;
    result = result * 31 + Kotlin.hashCode(this.beforeSend) | 0;
    result = result * 31 + Kotlin.hashCode(this.data) | 0;
    result = result * 31 + Kotlin.hashCode(this.httpType) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataType) | 0;
    result = result * 31 + Kotlin.hashCode(this.minLength) | 0;
    result = result * 31 + Kotlin.hashCode(this.cache) | 0;
    result = result * 31 + Kotlin.hashCode(this.clearOnEmpty) | 0;
    result = result * 31 + Kotlin.hashCode(this.clearOnError) | 0;
    result = result * 31 + Kotlin.hashCode(this.emptyRequest) | 0;
    result = result * 31 + Kotlin.hashCode(this.requestDelay) | 0;
    result = result * 31 + Kotlin.hashCode(this.restoreOnError) | 0;
    result = result * 31 + Kotlin.hashCode(this.preserveSelected) | 0;
    result = result * 31 + Kotlin.hashCode(this.processData) | 0;
    return result;
  };
  AjaxOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.url, other.url) && Kotlin.equals(this.preprocessData, other.preprocessData) && Kotlin.equals(this.beforeSend, other.beforeSend) && Kotlin.equals(this.data, other.data) && Kotlin.equals(this.httpType, other.httpType) && Kotlin.equals(this.dataType, other.dataType) && Kotlin.equals(this.minLength, other.minLength) && Kotlin.equals(this.cache, other.cache) && Kotlin.equals(this.clearOnEmpty, other.clearOnEmpty) && Kotlin.equals(this.clearOnError, other.clearOnError) && Kotlin.equals(this.emptyRequest, other.emptyRequest) && Kotlin.equals(this.requestDelay, other.requestDelay) && Kotlin.equals(this.restoreOnError, other.restoreOnError) && Kotlin.equals(this.preserveSelected, other.preserveSelected) && Kotlin.equals(this.processData, other.processData)))));
  };
  function toJs$lambda(this$toJs, closure$emptyOption) {
    return function (data) {
      var tmp$, tmp$_0, tmp$_1;
      var processedData = (tmp$_0 = (tmp$ = this$toJs.preprocessData) != null ? tmp$(data) : null) != null ? tmp$_0 : data;
      if (closure$emptyOption) {
        var $receiver = new Object_init();
        $receiver.value = BootstrapSelectModule_getInstance().KVNULL_8be2vx$;
        $receiver.text = '';
        var ret = mutableListOf([$receiver]);
        ret.addAll_brywnq$(asList(Kotlin.isArray(tmp$_1 = processedData) ? tmp$_1 : throwCCE()));
        return copyToArray(ret);
      } else {
        return processedData;
      }
    };
  }
  function toJs($receiver, emptyOption) {
    var procData = toJs$lambda($receiver, emptyOption);
    var language = i18n.I18n.language;
    var $receiver_0 = new Object_init();
    var $receiver_1 = new Object_init();
    var tmp$;
    $receiver_1.url = (tmp$ = $receiver.url) != null ? tmp$ : '/';
    $receiver_1.method = $receiver.httpType.type_8be2vx$;
    $receiver_1.dataType = $receiver.dataType.type_8be2vx$;
    $receiver_1.data = $receiver.data;
    $receiver_1.beforeSend = $receiver.beforeSend;
    $receiver_1.contentType = 'application/json';
    $receiver_0.ajax = $receiver_1;
    $receiver_0.preprocessData = procData;
    $receiver_0.minLength = $receiver.minLength;
    $receiver_0.cache = $receiver.cache;
    $receiver_0.clearOnEmpty = $receiver.clearOnEmpty;
    $receiver_0.clearOnError = $receiver.clearOnError;
    $receiver_0.emptyRequest = $receiver.emptyRequest;
    $receiver_0.preserveSelected = $receiver.preserveSelected;
    $receiver_0.requestDelay = $receiver.requestDelay;
    $receiver_0.restoreOnError = $receiver.restoreOnError;
    $receiver_0.langCode = language;
    $receiver_0.processData = $receiver.processData;
    $receiver_0.preserveSelectedOrder = true;
    return $receiver_0;
  }
  function getBsInstance($receiver, constructor) {
    return constructor(BootstrapSelectModule_getInstance().bootstrap_8be2vx$).getInstance($receiver);
  }
  function Select(options, value, name, multiple, ajaxOptions, label, rich, init) {
    Select$Companion_getInstance();
    if (options === void 0)
      options = null;
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (multiple === void 0)
      multiple = false;
    if (ajaxOptions === void 0)
      ajaxOptions = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-group kv-mb-3');
    this.idc_jfr56v$_0 = 'kv_form_select_' + Select$Companion_getInstance().counter_8be2vx$;
    var $receiver = new SelectInput(options, value, multiple, ajaxOptions, 'form-control');
    var closure$name = name;
    $receiver.id = this.idc_jfr56v$_0;
    $receiver.name = closure$name;
    this.input_1qseon$_0 = $receiver;
    this.flabel_8ul885$_0 = new FieldLabel(this.idc_jfr56v$_0, label, rich, 'form-label');
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_z71j45$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    this.addPrivate_87eobz$(this.flabel);
    this.addPrivate_87eobz$(this.input);
    this.addPrivate_87eobz$(this.invalidFeedback);
    tmp$ = Select$Companion_getInstance().counter_8be2vx$;
    Select$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(Select.prototype, 'options', {configurable: true, get: function () {
    return this.input.options;
  }, set: function (value) {
    this.input.options = value;
  }});
  Object.defineProperty(Select.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value;
  }});
  Object.defineProperty(Select.prototype, 'multiple', {configurable: true, get: function () {
    return this.input.multiple;
  }, set: function (value) {
    this.input.multiple = value;
  }});
  Object.defineProperty(Select.prototype, 'ajaxOptions', {configurable: true, get: function () {
    return this.input.ajaxOptions;
  }, set: function (value) {
    this.input.ajaxOptions = value;
  }});
  Object.defineProperty(Select.prototype, 'maxOptions', {configurable: true, get: function () {
    return this.input.maxOptions;
  }, set: function (value) {
    this.input.maxOptions = value;
  }});
  Object.defineProperty(Select.prototype, 'liveSearch', {configurable: true, get: function () {
    return this.input.liveSearch;
  }, set: function (value) {
    this.input.liveSearch = value;
  }});
  Object.defineProperty(Select.prototype, 'placeholder', {configurable: true, get: function () {
    return this.input.placeholder;
  }, set: function (value) {
    this.input.placeholder = value;
  }});
  Object.defineProperty(Select.prototype, 'style', {configurable: true, get: function () {
    return this.input.style;
  }, set: function (value) {
    this.input.style = value;
  }});
  Object.defineProperty(Select.prototype, 'selectWidth', {configurable: true, get: function () {
    return this.input.selectWidth;
  }, set: function (value) {
    this.input.selectWidth = value;
  }});
  Object.defineProperty(Select.prototype, 'selectWidthType', {configurable: true, get: function () {
    return this.input.selectWidthType;
  }, set: function (value) {
    this.input.selectWidthType = value;
  }});
  Object.defineProperty(Select.prototype, 'dropdownAlign', {configurable: true, get: function () {
    return this.input.dropdownAlign;
  }, set: function (value) {
    this.input.dropdownAlign = value;
  }});
  Object.defineProperty(Select.prototype, 'emptyOption', {configurable: true, get: function () {
    return this.input.emptyOption;
  }, set: function (value) {
    this.input.emptyOption = value;
  }});
  Object.defineProperty(Select.prototype, 'dropdownSize', {configurable: true, get: function () {
    return this.input.dropdownSize;
  }, set: function (value) {
    this.input.dropdownSize = value;
  }});
  Object.defineProperty(Select.prototype, 'dropdownShowAll', {configurable: true, get: function () {
    return this.input.dropdownShowAll;
  }, set: function (value) {
    this.input.dropdownShowAll = value;
  }});
  Object.defineProperty(Select.prototype, 'autofocus', {configurable: true, get: function () {
    return this.input.autofocus;
  }, set: function (value) {
    this.input.autofocus = value;
  }});
  Object.defineProperty(Select.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(Select.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(Select.prototype, 'selectedIndex', {configurable: true, get: function () {
    return this.input.selectedIndex;
  }, set: function (value) {
    this.input.selectedIndex = value;
  }});
  Object.defineProperty(Select.prototype, 'selectedLabel', {configurable: true, get: function () {
    return this.input.selectedLabel;
  }, set: function (value) {
    this.input.selectedLabel = value;
  }});
  Object.defineProperty(Select.prototype, 'input', {configurable: true, get: function () {
    return this.input_1qseon$_0;
  }});
  Object.defineProperty(Select.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_8ul885$_0;
  }});
  Object.defineProperty(Select.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_z71j45$_0;
  }});
  Select.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
      classSetBuilder.add_61zpoe$('select-parent');
    }};
  Select.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  Select.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  Select.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  Select.prototype.add_87eobz$ = function (child) {
    this.input.add_87eobz$(child);
    return this;
  };
  Select.prototype.add_pqktxj$ = function (position, child) {
    this.input.add_pqktxj$(position, child);
    return this;
  };
  Select.prototype.addAll_xquxs0$ = function (children) {
    this.input.addAll_xquxs0$(children);
    return this;
  };
  Select.prototype.remove_87eobz$ = function (child) {
    this.input.remove_87eobz$(child);
    return this;
  };
  Select.prototype.removeAt_za3lpa$ = function (position) {
    this.input.removeAt_za3lpa$(position);
    return this;
  };
  Select.prototype.removeAll = function () {
    this.input.removeAll();
    return this;
  };
  Select.prototype.disposeAll = function () {
    this.input.disposeAll();
    return this;
  };
  Select.prototype.getChildren = function () {
    return this.input.getChildren();
  };
  Select.prototype.showOptions = function () {
    this.input.showOptions();
  };
  Select.prototype.hideOptions = function () {
    this.input.hideOptions();
  };
  Select.prototype.toggleOptions = function () {
    this.input.toggleOptions();
  };
  Select.prototype.focus = function () {
    this.input.focus();
  };
  Select.prototype.blur = function () {
    this.input.blur();
  };
  Select.prototype.getState = function () {
    return this.input.getState();
  };
  Select.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  Select.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  function Select$Companion() {
    Select$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  Select$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Select$Companion_instance = null;
  function Select$Companion_getInstance() {
    if (Select$Companion_instance === null) {
      new Select$Companion();
    }return Select$Companion_instance;
  }
  Select.$metadata$ = {kind: Kind_CLASS, simpleName: 'Select', interfaces: [MutableState, StringFormControl, SimplePanel]};
  function Widget$refreshOnUpdate$lambda(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_0(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var SelectWidthType$AUTO_instance;
  var SelectWidthType$FIT_instance;
  function SelectDropdownAlign(name, ordinal) {
    Enum.call(this);
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function SelectDropdownAlign_initFields() {
    SelectDropdownAlign_initFields = function () {
    };
    SelectDropdownAlign$AUTO_instance = new SelectDropdownAlign('AUTO', 0);
    SelectDropdownAlign$LEFT_instance = new SelectDropdownAlign('LEFT', 1);
    SelectDropdownAlign$RIGHT_instance = new SelectDropdownAlign('RIGHT', 2);
  }
  var SelectDropdownAlign$AUTO_instance;
  function SelectDropdownAlign$AUTO_getInstance() {
    SelectDropdownAlign_initFields();
    return SelectDropdownAlign$AUTO_instance;
  }
  var SelectDropdownAlign$LEFT_instance;
  function SelectDropdownAlign$LEFT_getInstance() {
    SelectDropdownAlign_initFields();
    return SelectDropdownAlign$LEFT_instance;
  }
  var SelectDropdownAlign$RIGHT_instance;
  function SelectDropdownAlign$RIGHT_getInstance() {
    SelectDropdownAlign_initFields();
    return SelectDropdownAlign$RIGHT_instance;
  }
  SelectDropdownAlign.$metadata$ = {kind: Kind_CLASS, simpleName: 'SelectDropdownAlign', interfaces: [Enum]};
  function SelectDropdownAlign$values() {
    return [SelectDropdownAlign$AUTO_getInstance(), SelectDropdownAlign$LEFT_getInstance(), SelectDropdownAlign$RIGHT_getInstance()];
  }
  SelectDropdownAlign.values = SelectDropdownAlign$values;
  function SelectDropdownAlign$valueOf(name) {
    switch (name) {
      case 'AUTO':
        return SelectDropdownAlign$AUTO_getInstance();
      case 'LEFT':
        return SelectDropdownAlign$LEFT_getInstance();
      case 'RIGHT':
        return SelectDropdownAlign$RIGHT_getInstance();
      default:throwISE('No enum constant io.kvision.form.select.SelectDropdownAlign.' + name);
    }
  }
  SelectDropdownAlign.valueOf_61zpoe$ = SelectDropdownAlign$valueOf;
  function SelectInput(options, value, multiple, ajaxOptions, className, init) {
    SelectInput$Companion_getInstance();
    if (options === void 0)
      options = null;
    if (value === void 0)
      value = null;
    if (multiple === void 0)
      multiple = false;
    if (ajaxOptions === void 0)
      ajaxOptions = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.observers = ArrayList_init();
    this.initialized_3p5ssx$_0 = false;
    this.options_761zpj$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, options, SelectInput$options$lambda(this))).provideDelegate_n5byny$(this, SelectInput$options_metadata);
    this.value_feq8k$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, value, SelectInput$value$lambda(this))).provideDelegate_n5byny$(this, SelectInput$value_metadata);
    this.name_g5bav0$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$name_metadata);
    this.multiple_tonwtb$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, multiple, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, SelectInput$multiple_metadata);
    this.ajaxOptions_gazzuh$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, ajaxOptions, SelectInput$ajaxOptions$lambda(this))).provideDelegate_n5byny$(this, SelectInput$ajaxOptions_metadata);
    this.maxOptions_40vyjv$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$maxOptions_metadata);
    this.liveSearch_nf1rwl$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, SelectInput$liveSearch_metadata);
    this.placeholder_wwies2$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$placeholder_metadata);
    this.style_p1xik$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$style_metadata);
    this.selectWidth_p8smth$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$selectWidth_metadata);
    this.selectWidthType_xn45cv$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$selectWidthType_metadata);
    this.dropdownAlign_njjya7$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, SelectDropdownAlign$LEFT_getInstance(), Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, SelectInput$dropdownAlign_metadata);
    this.emptyOption_bxxxml$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, SelectInput$emptyOption$lambda(this))).provideDelegate_n5byny$(this, SelectInput$emptyOption_metadata);
    this.dropdownSize_bxxa0z$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$dropdownSize_metadata);
    this.dropdownShowAll_6iuha$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, SelectInput$dropdownShowAll_metadata);
    this.disabled_ojxq19$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, SelectInput$disabled$lambda(this))).provideDelegate_n5byny$(this, SelectInput$disabled_metadata);
    this.autofocus_li1ow4$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$autofocus_metadata);
    this.size_g2eycy$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$size_metadata);
    this.validationStatus_laz5hg$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, SelectInput$validationStatus_metadata);
    this.useSnabbdomDistinctKey();
    this.setChildrenFromOptions_xrku6c$_0();
    this.setInternalEventListener_a1up2z$(SelectInput_init$lambda(this));
    init != null ? init(this) : null;
  }
  var SelectInput$options_metadata = new PropertyMetadata('options');
  Object.defineProperty(SelectInput.prototype, 'options', {configurable: true, get: function () {
    return this.options_761zpj$_0.getValue_fmbzy8$(this, SelectInput$options_metadata);
  }, set: function (options) {
    this.options_761zpj$_0.setValue_19qrsr$(this, SelectInput$options_metadata, options);
  }});
  var SelectInput$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(SelectInput.prototype, 'value', {configurable: true, get: function () {
    return this.value_feq8k$_0.getValue_fmbzy8$(this, SelectInput$value_metadata);
  }, set: function (value) {
    this.value_feq8k$_0.setValue_19qrsr$(this, SelectInput$value_metadata, value);
  }});
  var SelectInput$name_metadata = new PropertyMetadata('name');
  Object.defineProperty(SelectInput.prototype, 'name', {configurable: true, get: function () {
    return this.name_g5bav0$_0.getValue_fmbzy8$(this, SelectInput$name_metadata);
  }, set: function (name) {
    this.name_g5bav0$_0.setValue_19qrsr$(this, SelectInput$name_metadata, name);
  }});
  var SelectInput$multiple_metadata = new PropertyMetadata('multiple');
  Object.defineProperty(SelectInput.prototype, 'multiple', {configurable: true, get: function () {
    return this.multiple_tonwtb$_0.getValue_fmbzy8$(this, SelectInput$multiple_metadata);
  }, set: function (multiple) {
    this.multiple_tonwtb$_0.setValue_19qrsr$(this, SelectInput$multiple_metadata, multiple);
  }});
  var SelectInput$ajaxOptions_metadata = new PropertyMetadata('ajaxOptions');
  Object.defineProperty(SelectInput.prototype, 'ajaxOptions', {configurable: true, get: function () {
    return this.ajaxOptions_gazzuh$_0.getValue_fmbzy8$(this, SelectInput$ajaxOptions_metadata);
  }, set: function (ajaxOptions) {
    this.ajaxOptions_gazzuh$_0.setValue_19qrsr$(this, SelectInput$ajaxOptions_metadata, ajaxOptions);
  }});
  var SelectInput$maxOptions_metadata = new PropertyMetadata('maxOptions');
  Object.defineProperty(SelectInput.prototype, 'maxOptions', {configurable: true, get: function () {
    return this.maxOptions_40vyjv$_0.getValue_fmbzy8$(this, SelectInput$maxOptions_metadata);
  }, set: function (maxOptions) {
    this.maxOptions_40vyjv$_0.setValue_19qrsr$(this, SelectInput$maxOptions_metadata, maxOptions);
  }});
  var SelectInput$liveSearch_metadata = new PropertyMetadata('liveSearch');
  Object.defineProperty(SelectInput.prototype, 'liveSearch', {configurable: true, get: function () {
    return this.liveSearch_nf1rwl$_0.getValue_fmbzy8$(this, SelectInput$liveSearch_metadata);
  }, set: function (liveSearch) {
    this.liveSearch_nf1rwl$_0.setValue_19qrsr$(this, SelectInput$liveSearch_metadata, liveSearch);
  }});
  var SelectInput$placeholder_metadata = new PropertyMetadata('placeholder');
  Object.defineProperty(SelectInput.prototype, 'placeholder', {configurable: true, get: function () {
    return this.placeholder_wwies2$_0.getValue_fmbzy8$(this, SelectInput$placeholder_metadata);
  }, set: function (placeholder) {
    this.placeholder_wwies2$_0.setValue_19qrsr$(this, SelectInput$placeholder_metadata, placeholder);
  }});
  var SelectInput$style_metadata = new PropertyMetadata('style');
  Object.defineProperty(SelectInput.prototype, 'style', {configurable: true, get: function () {
    return this.style_p1xik$_0.getValue_fmbzy8$(this, SelectInput$style_metadata);
  }, set: function (style) {
    this.style_p1xik$_0.setValue_19qrsr$(this, SelectInput$style_metadata, style);
  }});
  var SelectInput$selectWidth_metadata = new PropertyMetadata('selectWidth');
  Object.defineProperty(SelectInput.prototype, 'selectWidth', {configurable: true, get: function () {
    return this.selectWidth_p8smth$_0.getValue_fmbzy8$(this, SelectInput$selectWidth_metadata);
  }, set: function (selectWidth) {
    this.selectWidth_p8smth$_0.setValue_19qrsr$(this, SelectInput$selectWidth_metadata, selectWidth);
  }});
  var SelectInput$selectWidthType_metadata = new PropertyMetadata('selectWidthType');
  Object.defineProperty(SelectInput.prototype, 'selectWidthType', {configurable: true, get: function () {
    return this.selectWidthType_xn45cv$_0.getValue_fmbzy8$(this, SelectInput$selectWidthType_metadata);
  }, set: function (selectWidthType) {
    this.selectWidthType_xn45cv$_0.setValue_19qrsr$(this, SelectInput$selectWidthType_metadata, selectWidthType);
  }});
  var SelectInput$dropdownAlign_metadata = new PropertyMetadata('dropdownAlign');
  Object.defineProperty(SelectInput.prototype, 'dropdownAlign', {configurable: true, get: function () {
    return this.dropdownAlign_njjya7$_0.getValue_fmbzy8$(this, SelectInput$dropdownAlign_metadata);
  }, set: function (dropdownAlign) {
    this.dropdownAlign_njjya7$_0.setValue_19qrsr$(this, SelectInput$dropdownAlign_metadata, dropdownAlign);
  }});
  var SelectInput$emptyOption_metadata = new PropertyMetadata('emptyOption');
  Object.defineProperty(SelectInput.prototype, 'emptyOption', {configurable: true, get: function () {
    return this.emptyOption_bxxxml$_0.getValue_fmbzy8$(this, SelectInput$emptyOption_metadata);
  }, set: function (emptyOption) {
    this.emptyOption_bxxxml$_0.setValue_19qrsr$(this, SelectInput$emptyOption_metadata, emptyOption);
  }});
  var SelectInput$dropdownSize_metadata = new PropertyMetadata('dropdownSize');
  Object.defineProperty(SelectInput.prototype, 'dropdownSize', {configurable: true, get: function () {
    return this.dropdownSize_bxxa0z$_0.getValue_fmbzy8$(this, SelectInput$dropdownSize_metadata);
  }, set: function (dropdownSize) {
    this.dropdownSize_bxxa0z$_0.setValue_19qrsr$(this, SelectInput$dropdownSize_metadata, dropdownSize);
  }});
  var SelectInput$dropdownShowAll_metadata = new PropertyMetadata('dropdownShowAll');
  Object.defineProperty(SelectInput.prototype, 'dropdownShowAll', {configurable: true, get: function () {
    return this.dropdownShowAll_6iuha$_0.getValue_fmbzy8$(this, SelectInput$dropdownShowAll_metadata);
  }, set: function (dropdownShowAll) {
    this.dropdownShowAll_6iuha$_0.setValue_19qrsr$(this, SelectInput$dropdownShowAll_metadata, dropdownShowAll);
  }});
  var SelectInput$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(SelectInput.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_ojxq19$_0.getValue_fmbzy8$(this, SelectInput$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_ojxq19$_0.setValue_19qrsr$(this, SelectInput$disabled_metadata, disabled);
  }});
  var SelectInput$autofocus_metadata = new PropertyMetadata('autofocus');
  Object.defineProperty(SelectInput.prototype, 'autofocus', {configurable: true, get: function () {
    return this.autofocus_li1ow4$_0.getValue_fmbzy8$(this, SelectInput$autofocus_metadata);
  }, set: function (autofocus) {
    this.autofocus_li1ow4$_0.setValue_19qrsr$(this, SelectInput$autofocus_metadata, autofocus);
  }});
  var SelectInput$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(SelectInput.prototype, 'size', {configurable: true, get: function () {
    return this.size_g2eycy$_0.getValue_fmbzy8$(this, SelectInput$size_metadata);
  }, set: function (size) {
    this.size_g2eycy$_0.setValue_19qrsr$(this, SelectInput$size_metadata, size);
  }});
  var SelectInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  Object.defineProperty(SelectInput.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.validationStatus_laz5hg$_0.getValue_fmbzy8$(this, SelectInput$validationStatus_metadata);
  }, set: function (validationStatus) {
    this.validationStatus_laz5hg$_0.setValue_19qrsr$(this, SelectInput$validationStatus_metadata, validationStatus);
  }});
  Object.defineProperty(SelectInput.prototype, 'selectedIndex', {configurable: true, get: function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    var tmp$_4;
    if ((tmp$_2 = (tmp$_0 = (tmp$ = this.getElement()) != null ? tmp$ : null) != null ? tmp$_0.selectedIndex : null) != null)
      tmp$_4 = tmp$_2;
    else {
      var tmp$_5;
      if ((tmp$_1 = this.value) != null) {
        var tmp$_6, tmp$_7, tmp$_8;
        var emptyIndex = this.emptyOption ? 1 : 0;
        var tmp$_9;
        if ((tmp$_6 = this.options) != null) {
          var transform = getPropertyCallableRef('first', 1, function ($receiver) {
            return $receiver.first;
          });
          var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$_6, 10));
          var tmp$_10;
          tmp$_10 = tmp$_6.iterator();
          while (tmp$_10.hasNext()) {
            var item = tmp$_10.next();
            destination.add_11rb$(transform(item));
          }
          tmp$_9 = destination;
        } else
          tmp$_9 = null;
        tmp$_5 = (tmp$_8 = (tmp$_7 = tmp$_9) != null ? tmp$_7.indexOf_11rb$(tmp$_1) : null) != null ? tmp$_8 + emptyIndex | 0 : null;
      } else
        tmp$_5 = null;
      tmp$_4 = tmp$_5;
    }
    return (tmp$_3 = tmp$_4) != null ? tmp$_3 : -1;
  }, set: function (value) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    (tmp$_0 = (tmp$ = this.getElement()) != null ? tmp$ : null) != null ? (tmp$_0.selectedIndex = value) : null;
    if (value === -1)
      this.value = null;
    if ((tmp$_2 = (tmp$_1 = this.options) != null ? getOrNull(tmp$_1, value) : null) != null) {
      this.value = tmp$_2.first;
    }}});
  Object.defineProperty(SelectInput.prototype, 'selectedLabel', {configurable: true, get: function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    var tmp$_4;
    if ((tmp$_3 = (tmp$_1 = (tmp$_0 = (tmp$ = getElementJQuery(this)) != null ? tmp$.next() : null) != null ? tmp$_0.prop('title') : null) != null ? tmp$_1.toString() : null) != null)
      tmp$_4 = tmp$_3;
    else {
      var tmp$_5;
      if ((tmp$_2 = this.value) != null) {
        var tmp$_6, tmp$_7;
        var tmp$_8;
        if ((tmp$_6 = this.options) != null) {
          var firstOrNull$result;
          firstOrNull$break: do {
            var tmp$_9;
            tmp$_9 = tmp$_6.iterator();
            while (tmp$_9.hasNext()) {
              var element = tmp$_9.next();
              if (equals(element.first, tmp$_2)) {
                firstOrNull$result = element;
                break firstOrNull$break;
              }}
            firstOrNull$result = null;
          }
           while (false);
          tmp$_8 = firstOrNull$result;
        } else
          tmp$_8 = null;
        tmp$_5 = (tmp$_7 = tmp$_8) != null ? tmp$_7.second : null;
      } else
        tmp$_5 = null;
      tmp$_4 = tmp$_5;
    }
    return tmp$_4;
  }, set: function (value) {
    var tmp$, tmp$_0;
    var button = (tmp$ = getElementJQuery(this)) != null ? tmp$.next() : null;
    button != null ? button.removeClass('bs-placeholder') : null;
    button != null ? button.prop('title', value != null ? value : '') : null;
    (tmp$_0 = button != null ? button.find('.filter-option-inner-inner') : null) != null ? tmp$_0.html(value != null ? value : '') : null;
  }});
  SelectInput.prototype.calculateValue_xdmamb$_0 = function (v) {
    var tmp$, tmp$_0, tmp$_1;
    if (this.multiple) {
      var arr = Kotlin.isArray(tmp$ = v) ? tmp$ : null;
      var tmp$_2 = arr != null;
      if (tmp$_2) {
        tmp$_2 = !(arr.length === 0);
      }if (tmp$_2) {
        var destination = ArrayList_init();
        var tmp$_3;
        for (tmp$_3 = 0; tmp$_3 !== arr.length; ++tmp$_3) {
          var element = arr[tmp$_3];
          if (!equals(element, ''))
            destination.add_11rb$(element);
        }
        tmp$_1 = joinToString(destination, ',');
      } else {
        tmp$_1 = null;
      }
    } else {
      var vs = typeof (tmp$_0 = v) === 'string' ? tmp$_0 : throwCCE();
      if (equals(BootstrapSelectModule_getInstance().KVNULL_8be2vx$, vs) || equals(vs, '')) {
        tmp$_1 = null;
      } else {
        tmp$_1 = vs;
      }
    }
    return tmp$_1;
  };
  SelectInput.prototype.render = function () {
    return h('span', this.getSnOptContents(), [this.render_pjwf99$('select', this.childrenVNodes())]);
  };
  SelectInput.prototype.add_87eobz$ = function (child) {
    SimplePanel.prototype.add_87eobz$.call(this, child);
    this.refreshSelectInput();
    return this;
  };
  SelectInput.prototype.add_pqktxj$ = function (position, child) {
    SimplePanel.prototype.add_pqktxj$.call(this, position, child);
    this.refreshSelectInput();
    return this;
  };
  SelectInput.prototype.addAll_xquxs0$ = function (children) {
    SimplePanel.prototype.addAll_xquxs0$.call(this, children);
    this.refreshSelectInput();
    return this;
  };
  SelectInput.prototype.remove_87eobz$ = function (child) {
    SimplePanel.prototype.remove_87eobz$.call(this, child);
    this.refreshSelectInput();
    return this;
  };
  SelectInput.prototype.removeAt_za3lpa$ = function (position) {
    SimplePanel.prototype.removeAt_za3lpa$.call(this, position);
    this.refreshSelectInput();
    return this;
  };
  SelectInput.prototype.removeAll = function () {
    SimplePanel.prototype.removeAll.call(this);
    this.refreshSelectInput();
    return this;
  };
  SelectInput.prototype.setChildrenFromOptions_xrku6c$_0 = function () {
    var tmp$;
    if (this.ajaxOptions == null) {
      SimplePanel.prototype.removeAll.call(this);
      if (this.emptyOption) {
        SimplePanel.prototype.add_87eobz$.call(this, new SelectOption(BootstrapSelectModule_getInstance().KVNULL_8be2vx$, ''));
      }if ((tmp$ = this.options) != null) {
        var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$, 10));
        var tmp$_0;
        tmp$_0 = tmp$.iterator();
        while (tmp$_0.hasNext()) {
          var item = tmp$_0.next();
          destination.add_11rb$(new SelectOption(item.first, item.second));
        }
        var c = destination;
        SimplePanel.prototype.addAll_xquxs0$.call(this, c);
      }}this.refreshSelectInput();
  };
  SelectInput.prototype.showOptions = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.selectpicker('open') : null;
  };
  SelectInput.prototype.hideOptions = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.selectpicker('close') : null;
  };
  SelectInput.prototype.toggleOptions = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.selectpicker('toggle') : null;
  };
  SelectInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('selectpicker');
    classSetBuilder.add_vqcfem$(this.validationStatus);
    classSetBuilder.add_vqcfem$(this.size);
  };
  function SelectInput$refreshSelectInput$lambda$lambda() {
    return Unit;
  }
  function SelectInput$refreshSelectInput$lambda(this$SelectInput) {
    return function () {
      var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
      (tmp$ = getElementJQueryD(this$SelectInput)) != null ? tmp$.selectpicker('refresh') : null;
      this$SelectInput.refreshState();
      (tmp$_3 = (tmp$_2 = (tmp$_1 = (tmp$_0 = getElementJQueryD(this$SelectInput)) != null ? tmp$_0.trigger('change') : null) != null ? tmp$_1.data('AjaxBootstrapSelect') : null) != null ? tmp$_2.list : null) != null ? (tmp$_3.cache = SelectInput$refreshSelectInput$lambda$lambda) : null;
      return Unit;
    };
  }
  SelectInput.prototype.refreshSelectInput = function () {
    window.setTimeout(SelectInput$refreshSelectInput$lambda(this), 0);
  };
  SelectInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6;
    SimplePanel.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('data-live-search', 'true');
    if ((tmp$ = this.name) != null) {
      attributeSetBuilder.add_puj7f4$('name', tmp$);
    }if (this.multiple) {
      attributeSetBuilder.add_puj7f4$('multiple');
    }if ((tmp$_0 = this.maxOptions) != null) {
      attributeSetBuilder.add_puj7f4$('data-max-options', '' + toString(tmp$_0));
    }if (this.placeholder != null) {
      attributeSetBuilder.add_puj7f4$('title', this.translate_61zpoe$(ensureNotNull(this.placeholder)));
    } else if (!this.emptyOption) {
      attributeSetBuilder.add_puj7f4$('title', '\xA0');
    }if (this.autofocus === true) {
      attributeSetBuilder.add_puj7f4$('autofocus');
    }if (this.disabled) {
      attributeSetBuilder.add_puj7f4$('disabled');
    }var btnStyle = (tmp$_2 = (tmp$_1 = this.style) != null ? tmp$_1.className : null) != null ? tmp$_2 : 'btn-default';
    tmp$_3 = this.size;
    if (equals(tmp$_3, InputSize.LARGE))
      tmp$_4 = btnStyle + ' btn-lg';
    else if (equals(tmp$_3, InputSize.SMALL))
      tmp$_4 = btnStyle + ' btn-sm';
    else
      tmp$_4 = btnStyle;
    attributeSetBuilder.add_puj7f4$('data-style', tmp$_4);
    var tmp$_7;
    if ((tmp$_5 = this.selectWidthType) != null) {
      attributeSetBuilder.add_puj7f4$('data-width', tmp$_5.value_8be2vx$);
      tmp$_7 = Unit;
    } else
      tmp$_7 = null;
    if (tmp$_7 == null) {
      if ((tmp$_6 = this.selectWidth) != null) {
        attributeSetBuilder.add_puj7f4$('data-width', asString(tmp$_6));
      }}switch (this.dropdownAlign.name) {
      case 'RIGHT':
        attributeSetBuilder.add_puj7f4$('data-dropdown-align-right', 'true');
        break;
      case 'AUTO':
        attributeSetBuilder.add_puj7f4$('data-dropdown-align-right', 'auto');
        break;
      default:break;
    }
    if (this.dropdownShowAll) {
      attributeSetBuilder.add_puj7f4$('data-size', 'false');
    } else if (this.dropdownSize != null && ensureNotNull(this.dropdownSize) > 0) {
      attributeSetBuilder.add_puj7f4$('data-size', toString(this.dropdownSize));
    }};
  function SelectInput$afterInsert$lambda(this$SelectInput) {
    return function (e) {
      var tmp$;
      (tmp$ = getElementJQuery(this$SelectInput)) != null ? tmp$.trigger('show.bs.select', e) : null;
      return Unit;
    };
  }
  function SelectInput$afterInsert$lambda$lambda(this$SelectInput) {
    return function () {
      var tmp$, tmp$_0, tmp$_1;
      return (tmp$_1 = (tmp$_0 = (tmp$ = this$SelectInput.getElement()) != null ? tmp$.parentElement : null) != null ? tmp$_0.classList : null) != null ? (tmp$_1.add('show'), Unit) : null;
    };
  }
  function SelectInput$afterInsert$lambda$lambda$lambda(closure$input) {
    return function () {
      closure$input.focus();
      return Unit;
    };
  }
  function SelectInput$afterInsert$lambda_0(this$SelectInput) {
    return function (e) {
      var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
      window.setTimeout(SelectInput$afterInsert$lambda$lambda(this$SelectInput), 0);
      if ((tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = getElementJQuery(this$SelectInput)) != null ? tmp$.parent() : null) != null ? tmp$_0.find("input[type='search']") : null) != null ? tmp$_1[0] : null) != null) {
        if (!this$SelectInput.liveSearch) {
          tmp$_2.style.position = 'absolute';
          tmp$_2.style.left = '-30000px';
        }window.setTimeout(SelectInput$afterInsert$lambda$lambda$lambda(tmp$_2), 0);
      }(tmp$_3 = getElementJQuery(this$SelectInput)) != null ? tmp$_3.trigger('shown.bs.select', e) : null;
      return Unit;
    };
  }
  function SelectInput$afterInsert$lambda_1(this$SelectInput) {
    return function (e) {
      var tmp$;
      (tmp$ = getElementJQuery(this$SelectInput)) != null ? tmp$.trigger('hide.bs.select', e) : null;
      return Unit;
    };
  }
  function SelectInput$afterInsert$lambda_2(this$SelectInput) {
    return function (e) {
      var tmp$, tmp$_0, tmp$_1, tmp$_2;
      (tmp$_1 = (tmp$_0 = (tmp$ = this$SelectInput.getElement()) != null ? tmp$.parentElement : null) != null ? tmp$_0.classList : null) != null ? (tmp$_1.remove('show'), Unit) : null;
      (tmp$_2 = getElementJQuery(this$SelectInput)) != null ? tmp$_2.trigger('hidden.bs.select', e) : null;
      return Unit;
    };
  }
  function SelectInput$afterInsert$lambda$lambda_0($receiver) {
    return $receiver.Dropdown;
  }
  function SelectInput$afterInsert$lambda_3(this$SelectInput) {
    return function (f, f_0) {
      var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
      if (!this$SelectInput.multiple) {
        (tmp$_3 = (tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = this$SelectInput.getElement()) != null ? tmp$.parentElement : null) != null ? tmp$_0.childNodes : null) != null ? tmp$_1[1] : null) != null ? getBsInstance(tmp$_2, SelectInput$afterInsert$lambda$lambda_0) : null) != null ? tmp$_3.hide() : null;
      }return Unit;
    };
  }
  SelectInput.prototype.afterInsert_77isfd$ = function (node) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10;
    var tmp$_11;
    if ((tmp$ = this.ajaxOptions) != null) {
      var tmp$_12;
      tmp$_11 = ((tmp$_12 = getElementJQueryD(this)) != null ? tmp$_12.selectpicker('render') : null).ajaxSelectPicker(toJs(tmp$, this.emptyOption));
    } else
      tmp$_11 = null;
    (tmp$_1 = tmp$_11) != null ? tmp$_1 : (tmp$_0 = getElementJQueryD(this)) != null ? tmp$_0.selectpicker('render') : null;
    (tmp$_3 = (tmp$_2 = this.getElement()) != null ? tmp$_2.parentElement : null) != null ? (tmp$_3.addEventListener('show.bs.dropdown', SelectInput$afterInsert$lambda(this)), Unit) : null;
    (tmp$_5 = (tmp$_4 = this.getElement()) != null ? tmp$_4.parentElement : null) != null ? (tmp$_5.addEventListener('shown.bs.dropdown', SelectInput$afterInsert$lambda_0(this)), Unit) : null;
    (tmp$_7 = (tmp$_6 = this.getElement()) != null ? tmp$_6.parentElement : null) != null ? (tmp$_7.addEventListener('hide.bs.dropdown', SelectInput$afterInsert$lambda_1(this)), Unit) : null;
    (tmp$_9 = (tmp$_8 = this.getElement()) != null ? tmp$_8.parentElement : null) != null ? (tmp$_9.addEventListener('hidden.bs.dropdown', SelectInput$afterInsert$lambda_2(this)), Unit) : null;
    (tmp$_10 = getElementJQuery(this)) != null ? tmp$_10.on('changed.bs.select', SelectInput$afterInsert$lambda_3(this)) : null;
    this.refreshState();
    this.initialized_3p5ssx$_0 = true;
  };
  SelectInput.prototype.afterDestroy = function () {
    var tmp$;
    if (this.initialized_3p5ssx$_0) {
      (tmp$ = getElementJQueryD(this)) != null ? tmp$.selectpicker('destroy') : null;
      this.initialized_3p5ssx$_0 = false;
    }};
  SelectInput.prototype.bindAllJQueryListeners = function () {
    bindAllJQueryListeners(this, this.jqueryListenersMap);
  };
  SelectInput.prototype.removeAllJQueryListeners = function () {
    removeAllJQueryListeners(this, this.jqueryListenersMap);
  };
  SelectInput.prototype.refreshState = function () {
    var tmp$;
    var tmp$_0, tmp$_1;
    if (this.ajaxOptions == null) {
      var tmp$_2;
      if ((tmp$ = this.value) != null) {
        var block$result;
        var tmp$_3, tmp$_4;
        if (this.multiple) {
          block$result = (tmp$_3 = getElementJQueryD(this)) != null ? tmp$_3.selectpicker('val', copyToArray(split(tmp$, [',']))) : null;
        } else {
          block$result = (tmp$_4 = getElementJQueryD(this)) != null ? tmp$_4.selectpicker('val', tmp$) : null;
        }
        tmp$_2 = block$result;
      } else
        tmp$_2 = null;
      if (tmp$_2 == null) {
        var tmp$_5, tmp$_6;
        (tmp$_5 = getElementJQueryD(this)) != null ? tmp$_5.selectpicker('val', null) : null;
        (tmp$_6 = this.getElementD()) != null ? (tmp$_6.selectedIndex = -1) : null;
      }} else if (this.value == null) {
      (tmp$_0 = getElementJQueryD(this)) != null ? tmp$_0.selectpicker('val', null) : null;
      (tmp$_1 = this.getElementD()) != null ? (tmp$_1.selectedIndex = -1) : null;
    }};
  SelectInput.prototype.getState = function () {
    return this.value;
  };
  function SelectInput$subscribe$lambda(this$SelectInput, closure$observer) {
    return function () {
      var $receiver = this$SelectInput.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  SelectInput.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return SelectInput$subscribe$lambda(this, observer);
  };
  SelectInput.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function SelectInput$Companion() {
    SelectInput$Companion_instance = this;
    BootstrapSelectModule_getInstance().initialize();
  }
  SelectInput$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var SelectInput$Companion_instance = null;
  function SelectInput$Companion_getInstance() {
    if (SelectInput$Companion_instance === null) {
      new SelectInput$Companion();
    }return SelectInput$Companion_instance;
  }
  function SelectInput$options$lambda(this$SelectInput) {
    return function (it) {
      this$SelectInput.setChildrenFromOptions_xrku6c$_0();
      return Unit;
    };
  }
  function SelectInput$value$lambda(this$SelectInput) {
    return function (it) {
      this$SelectInput.refreshState();
      var tmp$;
      tmp$ = this$SelectInput.observers.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(it);
      }
      return Unit;
    };
  }
  function SelectInput$ajaxOptions$lambda(this$SelectInput) {
    return function (it) {
      if (it != null) {
        this$SelectInput.liveSearch = true;
      }this$SelectInput.refresh();
      return Unit;
    };
  }
  function SelectInput$emptyOption$lambda(this$SelectInput) {
    return function (it) {
      this$SelectInput.setChildrenFromOptions_xrku6c$_0();
      return Unit;
    };
  }
  function SelectInput$disabled$lambda(this$SelectInput) {
    return function (it) {
      this$SelectInput.refresh();
      this$SelectInput.refreshSelectInput();
      return Unit;
    };
  }
  function SelectInput_init$lambda$lambda(this$SelectInput, this$) {
    return function (it) {
      var tmp$;
      var v = (tmp$ = getElementJQuery(this$SelectInput)) != null ? tmp$.val() : null;
      var tmp$_0 = this$.self;
      var tmp$_1;
      tmp$_1 = v != null ? this$SelectInput.calculateValue_xdmamb$_0(v) : null;
      tmp$_0.value = tmp$_1;
      return Unit;
    };
  }
  function SelectInput_init$lambda(this$SelectInput) {
    return function ($receiver) {
      $receiver.change = SelectInput_init$lambda$lambda(this$SelectInput, $receiver);
      return Unit;
    };
  }
  SelectInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'SelectInput', interfaces: [MutableState, FormInput, GenericFormComponent, SimplePanel]};
  var SelectOptGroup$label_metadata = new PropertyMetadata('label');
  var SelectOptGroup$options_metadata = new PropertyMetadata('options');
  var SelectOptGroup$maxOptions_metadata = new PropertyMetadata('maxOptions');
  var SelectOptGroup$disabled_metadata = new PropertyMetadata('disabled');
  function Widget$refreshOnUpdate$lambda_2(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function SelectOption(value, label, subtext, icon, divider, disabled, selected, className, init) {
    if (value === void 0)
      value = null;
    if (label === void 0)
      label = null;
    if (subtext === void 0)
      subtext = null;
    if (icon === void 0)
      icon = null;
    if (divider === void 0)
      divider = false;
    if (disabled === void 0)
      disabled = false;
    if (selected === void 0)
      selected = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Widget.call(this, className);
    this.value_3a6d23$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, value, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, SelectOption$value_metadata);
    this.label_1ggkg8$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, label, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, SelectOption$label_metadata);
    this.subtext_ijnlb3$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, subtext, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, SelectOption$subtext_metadata);
    this.icon_4o9us1$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, icon, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, SelectOption$icon_metadata);
    this.divider_cdqt8t$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, divider, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, SelectOption$divider_metadata);
    this.disabled_5hy1f8$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, disabled, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, SelectOption$disabled_metadata);
    this.selected_uq0d83$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, selected, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, SelectOption$selected_metadata);
    init != null ? init(this) : null;
  }
  var SelectOption$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(SelectOption.prototype, 'value', {configurable: true, get: function () {
    return this.value_3a6d23$_0.getValue_fmbzy8$(this, SelectOption$value_metadata);
  }, set: function (value) {
    this.value_3a6d23$_0.setValue_19qrsr$(this, SelectOption$value_metadata, value);
  }});
  var SelectOption$label_metadata = new PropertyMetadata('label');
  Object.defineProperty(SelectOption.prototype, 'label', {configurable: true, get: function () {
    return this.label_1ggkg8$_0.getValue_fmbzy8$(this, SelectOption$label_metadata);
  }, set: function (label) {
    this.label_1ggkg8$_0.setValue_19qrsr$(this, SelectOption$label_metadata, label);
  }});
  var SelectOption$subtext_metadata = new PropertyMetadata('subtext');
  Object.defineProperty(SelectOption.prototype, 'subtext', {configurable: true, get: function () {
    return this.subtext_ijnlb3$_0.getValue_fmbzy8$(this, SelectOption$subtext_metadata);
  }, set: function (subtext) {
    this.subtext_ijnlb3$_0.setValue_19qrsr$(this, SelectOption$subtext_metadata, subtext);
  }});
  var SelectOption$icon_metadata = new PropertyMetadata('icon');
  Object.defineProperty(SelectOption.prototype, 'icon', {configurable: true, get: function () {
    return this.icon_4o9us1$_0.getValue_fmbzy8$(this, SelectOption$icon_metadata);
  }, set: function (icon) {
    this.icon_4o9us1$_0.setValue_19qrsr$(this, SelectOption$icon_metadata, icon);
  }});
  var SelectOption$divider_metadata = new PropertyMetadata('divider');
  Object.defineProperty(SelectOption.prototype, 'divider', {configurable: true, get: function () {
    return this.divider_cdqt8t$_0.getValue_fmbzy8$(this, SelectOption$divider_metadata);
  }, set: function (divider) {
    this.divider_cdqt8t$_0.setValue_19qrsr$(this, SelectOption$divider_metadata, divider);
  }});
  var SelectOption$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(SelectOption.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_5hy1f8$_0.getValue_fmbzy8$(this, SelectOption$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_5hy1f8$_0.setValue_19qrsr$(this, SelectOption$disabled_metadata, disabled);
  }});
  var SelectOption$selected_metadata = new PropertyMetadata('selected');
  Object.defineProperty(SelectOption.prototype, 'selected', {configurable: true, get: function () {
    return this.selected_uq0d83$_0.getValue_fmbzy8$(this, SelectOption$selected_metadata);
  }, set: function (selected) {
    this.selected_uq0d83$_0.setValue_19qrsr$(this, SelectOption$selected_metadata, selected);
  }});
  SelectOption.prototype.render = function () {
    var tmp$, tmp$_0;
    if (!this.divider) {
      tmp$_0 = this.render_pjwf99$('option', [(tmp$ = this.translate_pdl1vj$(this.label)) != null ? tmp$ : this.value]);
    } else {
      tmp$_0 = this.render_61zpoe$('option');
    }
    return tmp$_0;
  };
  SelectOption.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if (!this.divider) {
      if ((tmp$ = this.value) != null) {
        attributeSetBuilder.add_puj7f4$('value', tmp$);
      }if ((tmp$_0 = this.subtext) != null) {
        attributeSetBuilder.add_puj7f4$('data-subtext', this.translate_61zpoe$(tmp$_0));
      }if ((tmp$_1 = this.icon) != null) {
        attributeSetBuilder.add_puj7f4$('data-icon', tmp$_1);
      }if (this.disabled) {
        attributeSetBuilder.add_puj7f4$('disabled');
      }if (this.selected) {
        attributeSetBuilder.add_puj7f4$('selected');
      }} else {
      attributeSetBuilder.add_puj7f4$('data-divider', 'true');
    }
  };
  SelectOption.$metadata$ = {kind: Kind_CLASS, simpleName: 'SelectOption', interfaces: [Widget]};
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'BootstrapSelectModule', {get: BootstrapSelectModule_getInstance});
  Object.defineProperty(HttpType, 'GET', {get: HttpType$GET_getInstance});
  Object.defineProperty(HttpType, 'POST', {get: HttpType$POST_getInstance});
  var package$form = package$kvision.form || (package$kvision.form = {});
  var package$select = package$form.select || (package$form.select = {});
  package$select.HttpType = HttpType;
  Object.defineProperty(DataType, 'JSON', {get: DataType$JSON_getInstance});
  Object.defineProperty(DataType, 'JSONP', {get: DataType$JSONP_getInstance});
  Object.defineProperty(DataType, 'XML', {get: DataType$XML_getInstance});
  Object.defineProperty(DataType, 'TEXT', {get: DataType$TEXT_getInstance});
  Object.defineProperty(DataType, 'SCRIPT', {get: DataType$SCRIPT_getInstance});
  package$select.DataType = DataType;
  package$select.AjaxOptions = AjaxOptions;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  package$select.toJs_xal57b$ = toJs;
  package$select.getBsInstance_fpdjl9$ = getBsInstance;
  Object.defineProperty(Select, 'Companion', {get: Select$Companion_getInstance});
  package$select.Select = Select;
  Object.defineProperty(SelectDropdownAlign, 'AUTO', {get: SelectDropdownAlign$AUTO_getInstance});
  Object.defineProperty(SelectDropdownAlign, 'LEFT', {get: SelectDropdownAlign$LEFT_getInstance});
  Object.defineProperty(SelectDropdownAlign, 'RIGHT', {get: SelectDropdownAlign$RIGHT_getInstance});
  package$select.SelectDropdownAlign = SelectDropdownAlign;
  Object.defineProperty(SelectInput, 'Companion', {get: SelectInput$Companion_getInstance});
  package$select.SelectInput = SelectInput;
  package$select.SelectOption = SelectOption;
  Object.defineProperty(Select.prototype, 'disabled', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'disabled'));
  Object.defineProperty(Select.prototype, 'name', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'name'));
  Object.defineProperty(Select.prototype, 'size', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'size'));
  Object.defineProperty(Select.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'validationStatus'));
  Object.defineProperty(Select.prototype, 'validatorError', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'validatorError'));
  Select.prototype.getValue = StringFormControl.prototype.getValue;
  Select.prototype.getValueAsString = StringFormControl.prototype.getValueAsString;
  Select.prototype.setValue_s8jyv4$ = StringFormControl.prototype.setValue_s8jyv4$;
  Select.prototype.styleForHorizontalFormPanel_fn6884$ = StringFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  Select.prototype.styleForInlineFormPanel = StringFormControl.prototype.styleForInlineFormPanel;
  Select.prototype.styleForVerticalFormPanel = StringFormControl.prototype.styleForVerticalFormPanel;
  return _;
}));

//# sourceMappingURL=kvision-kvision-bootstrap-select-js-legacy.js.map
